import { Injectable } from '@angular/core';
import { WancomHttpService } from '../wancom-http/wancom-http.service';

@Injectable({
	providedIn: 'root',
})
export class RemoteTvCmdService {
	public url: string = 'tvThirdParty/';

	constructor(protected http: WancomHttpService) {}

	getTimer(faceId: number) {
		return this.http.get<DeviceGetCurrentInfoResponse>(
			`${this.url}getTimer/${faceId}`
		);
	}

	setTimer(faceId: number, timers: TimerConfTimerList[]) {
		return this.http.put(`${this.url}setTimer/${faceId}`, timers);
	}

	getDeviceInfos(faceId: number) {
		return this.http.get(`${this.url}getBasicInfo/${faceId}`);
	}

	getDevicePowerStatus(faceId: number) {
		return this.http.get<boolean>(`${this.url}getDevicePowerStatus/${faceId}`);
	}

	getDeviceListPowerStatus(faceIds: number[]) {
		return this.http.post<GetDeviceListPowerStatusResponse[]>(
			`${this.url}getDeviceListPowerStatus`,
			faceIds
		);
	}

	setPowerFace(faceId: number, powerValue: boolean) {
		return this.http.put(
			`${this.url}setPowerFace/${faceId}/${powerValue}`,
			null
		);
	}
}

export interface GetDeviceListPowerStatusResponse {
	faceId?: number;
	deviceId: string;
	power?: boolean;
}

export interface DeviceGetCurrentInfoBody {
	deviceIds: string[];
	isRequestStatistics: boolean;
	requestId: string;
	step: string;
}

export interface DeviceGetCurrentInfoResponse {
	apiVersion: number;
	errorCode: number;
	errorMessage: string;
	items: CurrentInfoItem;
	pageSize: number;
	startIndex: number;
	status: string;
	totalCount: number;
}

export interface CurrentInfoItem {
	failList: string[];
	successList: CurrentInfoSuccessList[];
	requestId: string;
}

export interface CurrentInfoSuccessList {
	deviceCheck: string;
	deviceIds: string[];
	deviceTimeHolidayList: DeviceTimeHolidayList[];
	holidayCnt: number;
	inputSourceList: InputSourceList[];
	mdcUpdateTime: MdcUpdateTime;
	modelKind: string;
	modelType: string;
	separatableDevice: boolean;
	support: boolean;
	timeClockConf: TimeClockConf;
	timeCurrentTime: string;
	timerClock: string;
	timerConfTimerList: TimerConfTimerList[];
	timerCount: number;
	timerHoliday: string;
}

export interface DeviceTimeHolidayList {
	command: string;
	day1: string;
	day2: string;
	deviceId: string;
	holidaySeq: number;
	month1: string;
	month2: string;
}

export interface InputSourceList {
	additionalProp1: any;
	additionalProp2: any;
	additionalProp3: any;
}

export interface MdcUpdateTime {
	date: number;
	day: number;
	hours: number;
	minutes: number;
	month: number;
	nanos: number;
	seconds: number;
	time: number;
	timezoneOffset: number;
	year: number;
}

export interface TimeClockConf {
	clockAmpm: number;
	clockDay: number;
	clockH: number;
	clockM: number;
	clockMon: number;
	clockY1: number;
	clockY2: number;
}

export class TimerConfTimerList {
	timerDataCount: number = 0;
	timerHolidayEnable: string = '0';
	/**
	 * Jour effectif pour le Timer ON au format bizarre '0000000' = Lun-Sam / '0100000' = Lun
     
     Si 1 => Jour d'allumage 
     
     DIM / LUN / MAR / MER / JEU / VEN / SAM
	 */
	timerManualWeekday: string = '0000000';
	/**
	 * - AM = '1' ex  18h
	 * - PM = '0' ex 06h du soir
	 */
	timerOffAmpm: string = '1';
	/**
	 * Heure d'arret du Timer
	 */
	timerOffH: string = '00';
	/**
	 * Minutes d'arret du Timer
	 */
	timerOffM: string = '00';
	/**
	 * Jour effectif pour le Timer OFF au format bizarre '0000000' = Lun-Sam / '0100000' = Lun
	 */
	timerOffManualWeekday: string = '0000000';
	/**	- 5 = cas spécifique cf TimerManualWeekDay
        - 4 = Sam-Dim
        - 3 = Lun-Sam
        - 2 = Lun-Ven
        - 1 = Tous les jours 
	 */
	timerOffRepeat: string = '5';
	/**
	 * Statut du timer Off : 0 = Off / 1 = On
	 */
	timerOffStatus: string = '0';
	/**
	 * - AM = '1' ex  18h
	 * - PM = '0' ex 06h du soir
	 */
	timerOnAmpm: string = '1';
	timerOnH: string = '00';
	timerOnM: string = '00';
	timerOnStatus: string = '0';
	timerRepeat: string = '5';
	timerSeq: number = 0;
	timerSource: string = '99';
	timerVolume: string = '0';
}
